(function ($) {
    function getInt($element, attribute, fallback) {
        var value = parseInt($element.attr(attribute), 10);

        return Number.isNaN(value) ? fallback : value;
    }

    function getBool($element, attribute) {
        return $element.attr(attribute) === '1';
    }

    function getSlideBy($element) {
        return $element.attr('data-slide-by') === 'page' ? 'page' : 1;
    }

    function getNavText() {
        return [
            "<span class='sr-only'>Previous slide</span><i class='icon-angle-left' aria-hidden='true'></i>",
            "<span class='sr-only'>Next slide</span><i class='icon-angle-right' aria-hidden='true'></i>",
        ];
    }

    function cleanDuplicateControls($carousel) {
        $carousel.children('.owl-nav').not(':first').remove();
        $carousel.children('.owl-dots').not(':first').remove();
    }

    function syncCarouselWidth($carousel) {
        var $parent = $carousel.parent();
        var parentWidth = Math.floor($parent.innerWidth());

        if (parentWidth > 0) {
            $carousel.css('width', parentWidth + 'px');
        }
    }

    function refreshCarousel($carousel) {
        syncCarouselWidth($carousel);
        $carousel.trigger('refresh.owl.carousel');
        cleanDuplicateControls($carousel);
    }

    function initCarousel(selector, defaults) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var desktopItems = getInt($carousel, 'data-items-desktop', defaults.desktopItems);
            var tabletItems = getInt($carousel, 'data-items-tablet', defaults.tabletItems);
            var mobileItems = getInt($carousel, 'data-items-mobile', defaults.mobileItems);
            var itemCount = getInt($carousel, defaults.countAttribute, 0);
            var hasMultiplePages = itemCount > desktopItems;
            var gap = getInt($carousel, 'data-gap', defaults.gap);
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultiplePages;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultiplePages;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                margin: gap,
                items: desktopItems,
                slideBy: getSlideBy($carousel),
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultiplePages,
                dots: dots && hasMultiplePages,
                navText: getNavText(),
                responsive: {
                    0: { items: mobileItems },
                    768: { items: tabletItems },
                    1200: { items: desktopItems },
                },
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initSingleSlideCarousel(selector) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var slideCount = getInt($carousel, 'data-slide-count', 0);
            var hasMultipleSlides = slideCount > 1;
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultipleSlides;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultipleSlides;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                items: 1,
                margin: 0,
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultipleSlides,
                dots: dots && hasMultipleSlides,
                navText: getNavText(),
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function refreshCarousels() {
        $('.gallery-slider.owl-carousel, .block-cpt-slider.owl-carousel, .taxonomy-posts-slider.owl-carousel, .logos-slider.owl-carousel, .grid-card-slider.owl-carousel, .text-image-slider.owl-carousel').each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                refreshCarousel($carousel);
            }
        });
    }

    function debounce(callback, delay) {
        var timer = null;

        return function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(callback, delay);
        };
    }

    function initLightboxes() {
        if (!$.fn.lightGallery) {
            return;
        }

        $('.gallery-lightbox').each(function () {
            var $gallery = $(this);

            if ($gallery.data('ddLightGallery')) {
                return;
            }

            $gallery.lightGallery({
                selector: '.gallery-lightbox-item',
                share: true,
                download: true,
                rotate: false,
                showThumbByDefault: true,
                loop: false,
                thumbnail: true,
                allowMediaOverlap: true,
                toggleThumb: true,
            });

            $gallery.data('ddLightGallery', true);
        });
    }

    function initReferenzenSliders() {
        $('[data-referenzen-slider]').each(function () {
            var $slider = $(this);

            if ($slider.data('ddReferenzenSlider')) {
                return;
            }

            var $viewport = $slider.find('.referenzen-viewport');
            var $cards = $slider.find('.referenzen-card');
            var $prev = $slider.find('.referenzen-prev');
            var $next = $slider.find('.referenzen-next');

            function visibleCards() {
                return $cards.filter(':not([hidden])');
            }

            function updateArrows() {
                if (!$viewport.length) {
                    return;
                }

                var viewport = $viewport.get(0);
                var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);

                $prev.prop('disabled', viewport.scrollLeft <= 2);
                $next.prop('disabled', viewport.scrollLeft >= maxScroll - 2 || maxScroll === 0);
            }

            function move(direction) {
                var $visible = visibleCards();
                var step = $visible.first().outerWidth() || $viewport.innerWidth();
                var gap = parseFloat($slider.find('.referenzen-track').css('column-gap')) || 0;

                $viewport.get(0).scrollBy({ left: direction * (step + gap), behavior: 'smooth' });
            }

            $prev.on('click', function () { move(-1); });
            $next.on('click', function () { move(1); });
            $viewport.on('scroll', debounce(updateArrows, 50));

            $slider.find('.referenzen-filter').on('click', function () {
                var $button = $(this);
                var filter = String($button.data('filter'));

                $slider.find('.referenzen-filter').removeClass('is-active').attr('aria-pressed', 'false');
                $button.addClass('is-active').attr('aria-pressed', 'true');

                $cards.each(function () {
                    var terms = String($(this).attr('data-terms') || '').split(/\s+/);
                    $(this).prop('hidden', filter !== 'all' && terms.indexOf(filter) === -1);
                });

                $viewport.scrollLeft(0);
                window.requestAnimationFrame(updateArrows);
            });

            $slider.data('ddReferenzenSlider', true);
            updateArrows();
        });
    }

    function initGewerkeSliders() {
        $('[data-gewerke-slider]').each(function () {
            var $slider = $(this);

            if ($slider.data('ddGewerkeSlider')) {
                return;
            }

            var $slides = $slider.find('[data-gewerke-slide]');
            var $stage = $slider.find('.gewerke-stage');
            var $current = $slider.find('[data-gewerke-current]');
            var currentIndex = 0;
            var touchStartX = null;
            var autoplayTimer = null;
            var autoplayPaused = false;

            function scheduleAutoplay() {
                window.clearTimeout(autoplayTimer);

                if (autoplayPaused || $slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                    return;
                }

                autoplayTimer = window.setTimeout(function () {
                    showSlide(currentIndex + 1);
                }, 5000);
            }

            function showSlide(nextIndex) {
                if ($slides.length < 2) {
                    return;
                }

                currentIndex = (nextIndex + $slides.length) % $slides.length;
                $slides.removeClass('is-active').attr('aria-hidden', 'true');
                $slides.eq(currentIndex).addClass('is-active').attr('aria-hidden', 'false');
                $current.text(String(currentIndex + 1).padStart(2, '0'));
                scheduleAutoplay();
            }

            function pauseAutoplay() {
                autoplayPaused = true;
                window.clearTimeout(autoplayTimer);
                $slider.addClass('is-autoplay-paused');
            }

            function resumeAutoplay() {
                autoplayPaused = false;
                $slider.removeClass('is-autoplay-paused');
                scheduleAutoplay();
            }

            $slider.on('click', '[data-gewerke-next]', function () { showSlide(currentIndex + 1); });
            $slider.on('click', '[data-gewerke-prev]', function () { showSlide(currentIndex - 1); });

            $stage.on('mouseenter', pauseAutoplay);
            $stage.on('mouseleave', resumeAutoplay);

            $slider.attr('tabindex', '0').on('keydown', function (event) {
                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    showSlide(currentIndex + 1);
                } else if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    showSlide(currentIndex - 1);
                }
            });

            $slider.on('touchstart', function (event) {
                window.clearTimeout(autoplayTimer);
                touchStartX = event.originalEvent.touches[0].clientX;
            });

            $slider.on('touchend', function (event) {
                if (touchStartX === null) {
                    return;
                }

                var distance = event.originalEvent.changedTouches[0].clientX - touchStartX;
                touchStartX = null;

                if (Math.abs(distance) > 50) {
                    showSlide(currentIndex + (distance < 0 ? 1 : -1));
                } else {
                    scheduleAutoplay();
                }
            });

            $slider.data('ddGewerkeSlider', true);
            scheduleAutoplay();
        });
    }

    function initCounterNumbers() {
        $('[data-counter-group]').each(function () {
            var $group = $(this);

            if ($group.data('ddCounterNumbers')) {
                return;
            }

            var duration = getInt($group, 'data-counter-duration', 1800);
            var $numbers = $group.find('[data-counter-number]');

            function showFinalValues() {
                $numbers.each(function () {
                    var $number = $(this);
                    var target = parseFloat($number.attr('data-counter-target')) || 0;
                    var decimals = getInt($number, 'data-counter-decimals', 0);

                    $number.text(target.toLocaleString(undefined, {
                        minimumFractionDigits: decimals,
                        maximumFractionDigits: decimals,
                    }));
                });
            }

            function animateNumbers() {
                $numbers.each(function () {
                    var $number = $(this);
                    var target = parseFloat($number.attr('data-counter-target')) || 0;
                    var decimals = getInt($number, 'data-counter-decimals', 0);
                    var startTime = null;

                    function tick(timestamp) {
                        startTime = startTime || timestamp;

                        var progress = Math.min((timestamp - startTime) / duration, 1);
                        var easedProgress = 1 - Math.pow(1 - progress, 3);
                        var current = target * easedProgress;

                        $number.text(current.toLocaleString(undefined, {
                            minimumFractionDigits: decimals,
                            maximumFractionDigits: decimals,
                        }));

                        if (progress < 1) {
                            window.requestAnimationFrame(tick);
                        }
                    }

                    $number.text((0).toFixed(decimals));
                    window.requestAnimationFrame(tick);
                });
            }

            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
                showFinalValues();
            } else {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            animateNumbers();
                            observer.unobserve(entry.target);
                        }
                    });
                }, { threshold: 0.3 });

                observer.observe(this);
            }

            $group.data('ddCounterNumbers', true);
        });
    }

    function initTeamFilters() {
        $('[data-team-filter]').each(function () {
            var $block = $(this);

            if ($block.data('ddTeamFilter')) {
                return;
            }

            var $cards = $block.find('.team-card');

            $block.on('click', '.team-filter', function () {
                var $button = $(this);
                var category = String($button.attr('data-team-category'));

                $block.find('.team-filter').removeClass('is-active').attr('aria-pressed', 'false');
                $button.addClass('is-active').attr('aria-pressed', 'true');

                $cards.each(function () {
                    var terms = String($(this).attr('data-team-terms') || '').split(/\s+/);
                    $(this).prop('hidden', category !== 'all' && terms.indexOf(category) === -1);
                });
            });

            $block.data('ddTeamFilter', true);
        });
    }

    function initCareerApplicationLinks() {
        var $applicationForm = $('.career-application-form').first();
        var $buttons = $('.karriere-job-button[data-career-position]');

        if (!$applicationForm.length || !$buttons.length) {
            return;
        }

        $applicationForm.attr('id', 'career-application');

        $buttons.on('click', function (event) {
            var position = String($(this).attr('data-career-position') || '').trim();
            var $positionRadio = $applicationForm.find('input[type="radio"][name="position"]').filter(function () {
                return String($(this).val() || '').trim() === position;
            }).first();
            var $siteHeader = $('.site-header.is-sticky');

            if ($siteHeader.length) {
                $siteHeader.addClass('navbar-fixed-top');
            }

            function getTargetTop() {
                var headerHeight = $siteHeader.outerHeight() || 0;

                return Math.max(0, $applicationForm.offset().top - headerHeight - 20);
            }

            event.preventDefault();

            if ($positionRadio.length) {
                $positionRadio.prop('checked', true).trigger('input').trigger('change');
            }

            window.scrollTo({
                top: getTargetTop(),
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            });

            window.setTimeout(function () {
                var correctedTop = getTargetTop();

                if (Math.abs(window.scrollY - correctedTop) > 2) {
                    window.scrollTo({ top: correctedTop, behavior: 'auto' });
                }
            }, 850);
        });
    }

    function initReferenzenGridFilters() {
        $('[data-referenzen-grid-filter]').each(function () {
            var $block = $(this);

            if ($block.data('ddReferenzenGridFilter')) {
                return;
            }

            var $cards = $block.find('.referenzen-grid-card');
            var $count = $block.find('[data-referenzen-visible-count]');
            var $label = $block.find('[data-referenzen-count-label]');

            $block.on('click', '.referenzen-grid-filter', function () {
                var $button = $(this);
                var category = String($button.attr('data-referenzen-category'));
                var visibleCount = 0;

                $block.find('.referenzen-grid-filter').removeClass('is-active').attr('aria-pressed', 'false');
                $button.addClass('is-active').attr('aria-pressed', 'true');

                $cards.each(function () {
                    var terms = String($(this).attr('data-referenzen-terms') || '').split(/\s+/);
                    var isVisible = category === 'all' || terms.indexOf(category) !== -1;

                    $(this).prop('hidden', !isVisible);
                    visibleCount += isVisible ? 1 : 0;
                });

                $count.text(visibleCount);
                $label.text(visibleCount === 1 ? 'Projekt' : 'Projekte');
            });

            $block.data('ddReferenzenGridFilter', true);
        });
    }

    $(function () {
        initLightboxes();
        initReferenzenSliders();
        initGewerkeSliders();
        initCounterNumbers();
        initTeamFilters();
        initCareerApplicationLinks();
        initReferenzenGridFilters();

        initCarousel('.gallery-slider.owl-carousel', {
            countAttribute: 'data-image-count',
            desktopItems: 1,
            tabletItems: 1,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.block-cpt-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.taxonomy-posts-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.logos-slider.owl-carousel', {
            countAttribute: 'data-logo-count',
            desktopItems: 4,
            tabletItems: 3,
            mobileItems: 2,
            gap: 24,
        });

        initCarousel('.grid-card-slider.owl-carousel', {
            countAttribute: 'data-card-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initSingleSlideCarousel('.text-image-slider.owl-carousel');

        $(window).on('load', refreshCarousels);
        $(window).on('resize orientationchange', debounce(refreshCarousels, 150));
    });
})(jQuery);

(function (window, document) {
    'use strict';

    function initMilestonesScroll(timeline) {
        var viewport = timeline.querySelector('.meilensteine-viewport');
        var hint = timeline.querySelector('.meilensteine-scroll-hint');
        var pointerId = null;
        var startX = 0;
        var startScrollLeft = 0;

        if (!viewport || !hint) {
            return;
        }

        function updateScrollState() {
            var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
            var progress = maxScroll ? viewport.scrollLeft / maxScroll : 0;

            timeline.classList.toggle('is-scrollable', maxScroll > 2);
            hint.style.setProperty('--meilensteine-scroll-progress', maxScroll ? 0.08 + (progress * 0.92) : 0);
        }

        function finishDrag() {
            if (pointerId === null) {
                return;
            }

            if (viewport.hasPointerCapture(pointerId)) {
                viewport.releasePointerCapture(pointerId);
            }

            pointerId = null;
            viewport.classList.remove('is-dragging');
        }

        viewport.addEventListener('scroll', updateScrollState, { passive: true });

        viewport.addEventListener('pointerdown', function (event) {
            if (event.pointerType === 'touch' || event.button !== 0) {
                return;
            }

            pointerId = event.pointerId;
            startX = event.clientX;
            startScrollLeft = viewport.scrollLeft;
            viewport.setPointerCapture(pointerId);
            viewport.classList.add('is-dragging');
            event.preventDefault();
        });

        viewport.addEventListener('pointermove', function (event) {
            if (event.pointerId !== pointerId) {
                return;
            }

            viewport.scrollLeft = startScrollLeft - (event.clientX - startX);
        });

        viewport.addEventListener('pointerup', finishDrag);
        viewport.addEventListener('pointercancel', finishDrag);
        viewport.addEventListener('lostpointercapture', function () {
            pointerId = null;
            viewport.classList.remove('is-dragging');
        });

        if (typeof window.ResizeObserver !== 'undefined') {
            new window.ResizeObserver(updateScrollState).observe(viewport);
        } else {
            window.addEventListener('resize', updateScrollState);
        }

        updateScrollState();
    }

    document.querySelectorAll('.meilensteine').forEach(initMilestonesScroll);
})(window, document);
